import { createAction } from '@reduxjs/toolkit';
import {UiStatusStateBase} from "./State";


export const storeUiStatusAction = createAction<UiStatusStateBase>('storeUiStatusAction');
